<template>
  <modal
    width="580px"
    :closeBtn="false"
    :logOutBtn="true"
    footerPadding="0"
    @close="close"
    :title="t('Payment Processing')"
  >
    <template #default>
      <p class="text">{{ t('Your payment is processing.') }}</p>
      <p class="text">
        {{ t('Contact our live chat support if you have any questions concerning your subscription. ') }}
      </p>
    </template>
  </modal>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue';
import { useI18n } from '@/composables';
import { getUserApiRequest } from '@/services/api/user-api';

const { t } = useI18n();

const intervalId = ref<ReturnType<typeof setInterval> | null>(null);

const close = () => {
  if (intervalId.value) {
    clearInterval(intervalId.value);
    intervalId.value = null;
  }
};

onMounted(() => {
  intervalId.value = setInterval(async () => {
    const userData = await getUserApiRequest();
    if (userData?.pendingInvoiceGeneration === false) {
      close();
      window.location.reload();
    }
  }, 3000);
});

onBeforeUnmount(() => {
  close();
});
</script>

<style lang="scss" scoped>
.text {
  font-size: 15px;
}
</style>
